<script>
import { mapGetters } from 'vuex';

export default {
  filters: {
    commaSeparateArray(value) { return value ? value.join(', ') : '' },
  },

  props: {
    batchName: { type: String }, // From router
  },

  data: () => ({
    batch: undefined,
    showCollectionOfRecord: undefined,
    showPackingOfRecord: undefined,
    reloadTrigger: 0,
  }),

  computed: {
    ...mapGetters('auth', ['userHasRole']),
    latestRecord() { return this.batch.records && this.batch.records.length > 0 ? this.batch.records[0] : undefined },
    isLayerAdmin() { return this.userHasRole('LayerAdmin') },
  },

  methods: {
    selectCollection(record) {
      this.showCollectionOfRecord = this.showCollectionOfRecord === record ? undefined : record;
      this.showPackingOfRecord = undefined;
    },
    selectPacking(record) {
      this.showPackingOfRecord = this.showPackingOfRecord === record ? undefined : record;
      this.showCollectionOfRecord = undefined;
    },
  },
}
</script>

<template>
  <div>

    <api-loader
      :key="reloadTrigger"
      method="get"
      :url="`v1/layers/batches/${encodeURIComponent(batchName)}`"
      @loaded="batch=$event" />

    <b-list-group v-if="batch">

      <b-list-group-item>

        <h4>Batch {{batch.name}}</h4>

        <div>Placed Date: {{batch.placed_date | formatDate('YYYY-MM-DD')}}</div>

        <div>Current Age: {{batch.age_in_weeks}} weeks</div>

        <div>Number of Chickens Placed: {{batch.number_placed}}</div>

        <div>Egg Mobiles: {{batch.egg_mobiles | commaSeparateArray}}</div>

        <div>Type of Hen: {{batch.type_of_hen}}</div>

        <div v-if="isLayerAdmin">
          Current Balance:
          <span v-if="latestRecord"> {{latestRecord.balance}} </span>
          <span v-else> ? </span>
        </div>

      </b-list-group-item>

      <b-list-group-item v-for="record in batch.records" :key="record.age_in_days" class="py-2">
        <div class="d-flex align-items-center">
          <div class="text-muted small text-nowrap"> {{record.date | formatDate('ddd YYYY-MM-DD')}} </div>
          <div class="ml-2 small text-nowrap">{{record.age_in_weeks}} weeks</div>

          <div class="ml-auto d-flex flex-wrap align-items-center justify-content-end">
            <b-badge v-if="record.collection_records&&record.collection_records.length>0"
              class="ml-2 clickable my-1"
              variant="secondary"
              @click="selectCollection(record)">
              Collection
            </b-badge>

            <b-badge v-if="record.packing_records&&record.packing_records.length>0"
              class="ml-2 clickable my-1"
              variant="warning text-white"
              @click="selectPacking(record)">
              Packing
            </b-badge>
          </div>

        </div>

        <div v-if="showCollectionOfRecord===record" class="mt-3">
          <b-card no-body class="p-2">
            <b-list-group flush>
              <b-list-group-item> Collection Records </b-list-group-item>
              <b-list-group-item v-for="collectionRecord in record.collection_records" :key="collectionRecord.id">
                <ul class="small">

                  <li> Person: {{collectionRecord.person}} </li>

                  <li> Number eggs: {{collectionRecord.number_eggs}} </li>

                  <li :class="{'faded-field':!collectionRecord.mortalities}"> {{collectionRecord.mortalities ? `Mortalities: ${collectionRecord.mortalities}` : 'No mortalities'}} </li>

                  <li :class="{'faded-field':!collectionRecord.bucket_food}">
                    <span v-if="collectionRecord.bucket_food">
                      Bucket food:
                      {{collectionRecord.bucket_food.weight_kg}} kg
                      (buckets {{collectionRecord.bucket_food.bucket_numbers | commaSeparateArray}})
                    </span>
                    <span v-else>No bucket food</span>
                  </li>

                  <li :class="{'faded-field':!collectionRecord.pre_peak_food}">
                    <span v-if="collectionRecord.pre_peak_food">
                      Pre peak food: {{collectionRecord.pre_peak_food.kilograms}} kg
                    </span>
                    <span v-else>No pre peak food</span>
                  </li>
                </ul>

                <div v-if="isLayerAdmin || record.can_delete">
                  <confirm-click>
                    <api-button
                      method="delete"
                      :url="`v1/layers/batches/${encodeURIComponent(batchName)}/collection-records/${collectionRecord.id}`"
                      class="btn btn-outline-danger btn-block"
                      @executed="reloadTrigger++">
                      <i class="fa fa-trash-o"></i>
                      Delete Collection Record {{record.date | formatDate('ddd YYYY-MM-DD')}}
                    </api-button>
                  </confirm-click>
                </div>
              </b-list-group-item>
            </b-list-group>
          </b-card>
        </div>

        <div v-if="showPackingOfRecord===record" class="mt-3">
          <b-card no-body class="p-2">
            <b-list-group flush>
              <b-list-group-item> Packing Records </b-list-group-item>
              <b-list-group-item v-for="packingRecord in record.packing_records" :key="packingRecord.id">
                <ul class="small">

                  <li> Person: {{packingRecord.person}} </li>

                  <li>
                    Sizes:
                    <ul v-if="packingRecord.sizes">
                      <li v-for="(num, name) in packingRecord.sizes" :key="name"> {{num}} {{name}} </li>
                    </ul>
                  </li>

                </ul>

                <div v-if="isLayerAdmin || record.can_delete">
                  <confirm-click>
                    <api-button
                      method="delete"
                      :url="`v1/layers/batches/${encodeURIComponent(batchName)}/packing-records/${packingRecord.id}`"
                      class="btn btn-outline-danger btn-block"
                      @executed="reloadTrigger++">
                      <i class="fa fa-trash-o"></i>
                      Delete Packing Record {{record.date | formatDate('ddd YYYY-MM-DD')}}
                    </api-button>
                  </confirm-click>
                </div>
              </b-list-group-item>
            </b-list-group>
          </b-card>
        </div>
      </b-list-group-item>

    </b-list-group>
  </div>
</template>

<style>
.faded-field {
  opacity: 0.4;
}
</style>



// WEBPACK FOOTER //
// src/layer/components/Batch.vue